import { render, staticRenderFns } from "./DecoSkinInventoryModal.vue?vue&type=template&id=97e437ea&"
import script from "./DecoSkinInventoryModal.vue?vue&type=script&lang=ts&"
export * from "./DecoSkinInventoryModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports